import React from 'react'
import PageBanner from "app/components/ui/PageBanner"
import SiteGrid from "app/components/ui/SiteGrid"
import './styles/OurStoryPage.css'
import HelmetTitle from "app/meta/HelmetTitle"
import SquareGrid from "app/components/ui/SquareGrid"
import ourStoryImg1 from 'app/assets/images/our-story-1.jpg'
import ourStoryImg2 from 'app/assets/images/our-story-2.jpg'
import ourStoryImg3 from 'app/assets/images/our-story-3.jpg'
import ourStoryImg4 from 'app/assets/images/our-story-4.jpg'
import whoImg1 from 'app/assets/images/who-1.jpg'
import whoImg2 from 'app/assets/images/who-2.jpg'
import whoImg3 from 'app/assets/images/who-3.jpg'
import ourMissionImg from 'app/assets/images/our-mission-img.jpg'
import { whyChooseUsData } from "app/data/aboutData"

export default function OurStoryPage() {

  const whyBoxRender = whyChooseUsData?.map((item, index) => {
    return <div
      key={index}
      className="why-box"
    >
      <div className="box-content">
        <h5>{item.title}</h5>
        <p>{item.text}</p>
      </div>
    </div>
  })

  return (
    <div className="our-story-page">
      <HelmetTitle title="Our Story" />
      <PageBanner
        title="Our Story"
        subtitle="From Humble Beginnings: Our Journey to Becoming a Top healthcare clinic"
      />
      <div className="page-content">
        <SiteGrid>
          <div className="section section-1">
            <div className="img-container">
              <img src={ourStoryImg1} alt="Our Story 1" />
              <img src={ourStoryImg2} alt="Our Story 2" />
              <img src={ourStoryImg3} alt="Our Story 3" />
              <img src={ourStoryImg4} alt="Our Story 4" />
              <div className="circle circle-1" />
              <SquareGrid
                columns={5}
                number={25}
              />
            </div>
            <div className="text-container">
              <h5>Our humble beginnings</h5>
              <h2>Putting Patients First: Aphrodite Healthcare's Story</h2>
              <p>
                At Aphrodite, our story is one of passion and dedication
                to improving the lives of our patients. Our journey began
                when a group of healthcare professionals came together with
                a shared vision of creating a healthcare facility that truly
                prioritizes the needs of its patients. We were inspired by the
                ancient Greek goddess Aphrodite, who embodied the ideals of beauty,
                love, and wellness. Our goal is to help our patients achieve optimal
                health and wellness so they can lead fulfilling lives.
                <br /><br />
                Since our inception, we have worked tirelessly to build a healthcare
                facility that provides world-class care to our patients. We have
                invested in state-of-the-art medical equipment and recruited a
                team of highly skilled and compassionate healthcare professionals
                who are dedicated to providing personalized care to each and every
                patient. Our commitment to excellence is reflected in everything we
                do, from our patient-centered approach to our focus on preventive care.
                At Aphrodite, we believe that every patient deserves the very best, and
                we are honored to be able to play a role in helping our patients achieve
                their health and wellness goals.
              </p>
            </div>
          </div>
        </SiteGrid>
        <SiteGrid>
          <div className="section section-1 rtl">
            <div className="img-container">
              <img src={ourMissionImg} alt="Our mission" />
            </div>
            <div className="text-container">
              <h5>Our Mission</h5>
              <h2>Providing exceptional healthcare services that meet the diverse needs of our community</h2>
              <p>
                At Aphrodite, we believe that access to high-quality healthcare
                is a fundamental right that should be available to everyone,
                regardless of their background or circumstances. Our mission
                is to provide compassionate care that is both accessible and
                affordable, so that our patients can live their lives to the
                fullest. We strive to create a welcoming and inclusive environment
                where patients feel comfortable seeking out care, and where our
                staff can provide the individualized attention and support that
                each patient deserves. Whether you are seeking routine medical
                services or more specialized care, we are here to help you
                achieve your health and wellness goals.
              </p>
            </div>
          </div>
        </SiteGrid>
        <SiteGrid>
          <div className="why-section">
            <div className="why-box title-box">
              <h5>Why Choose Us</h5>
            </div>
            {whyBoxRender}
            <div className="circle circle-1" />
            <div className="circle circle-2" />
            <SquareGrid color="#fff" />
          </div>
        </SiteGrid>
        <SiteGrid className="section section-2 center">
          <h5>Who We Are</h5>
          <h2>Building Healthy Communities</h2>
          <div className="imgs-flex">
            <div className="img-container">
              <img src={whoImg1} alt="Who 1" />
              <p>From Our Founders: Our Journey Toward Building a Better Healthcare Experience</p>
            </div>
            <div className="img-container">
              <p>Our Values: A Strong Foundation for Exceptional Care and Service</p>
              <img src={whoImg2} alt="Who 2" />
            </div>
            <div className="img-container">
              <img src={whoImg3} alt="Who 3" />
              <p>Our Mission: Bringing Accessible, Compassionate Care to you.</p>
            </div>
          </div>
        </SiteGrid>
      </div>
    </div>
  )
}
